module.exports = __webpack_public_path__ + "static/media/Lose.c2d7ccf3.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Lose.png
// module id = 194
// module chunks = 0